import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70a8fe47"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-settings__item" }
const _hoisted_2 = { class: "list-settings__item-wrapper" }
const _hoisted_3 = { class: "list-settings__item-wrapper" }

import { SettingsStore, useSettingsStore } from '@/store/settings';
import { toRefs } from 'vue';

interface IListSettingsItemProps {
  title: string;
  settingsIndex: number;
  settingsItemIndex: number;
}

const numberMax = 1000;


export default /*#__PURE__*/_defineComponent({
  __name: 'ListSettingsItem',
  props: {
    title: {},
    settingsIndex: {},
    settingsItemIndex: {}
  },
  setup(__props: any) {

const props = __props;

const settingsStore: SettingsStore = useSettingsStore();
const { settings } = settingsStore;



const { title, settingsIndex, settingsItemIndex } = toRefs(props);

const onNumberInput = (e: Event) => {
  if (e.target instanceof HTMLInputElement) {
    if (+e.target.value >= numberMax) {
      e.target.value = numberMax.toString();
      settings[settingsIndex.value][settingsItemIndex.value].count = parseInt(e.target.value);
    } else {
      settings[settingsIndex.value][settingsItemIndex.value].count = parseInt(e.target.value);
    }
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        class: "list-settings__item-checkbox",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(settings)[_unref(settingsIndex)][_unref(settingsItemIndex)].visibility) = $event))
      }, null, 512), [
        [_vModelCheckbox, _unref(settings)[_unref(settingsIndex)][_unref(settingsItemIndex)].visibility]
      ]),
      _createElementVNode("span", null, _toDisplayString(_unref(title)), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        type: "number",
        class: "list-settings__item-number",
        min: "0",
        max: numberMax,
        onInput: onNumberInput,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(settings)[_unref(settingsIndex)][_unref(settingsItemIndex)].count) = $event))
      }, null, 544), [
        [
          _vModelText,
          _unref(settings)[_unref(settingsIndex)][_unref(settingsItemIndex)].count,
          void 0,
          { number: true }
        ]
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "color",
        class: "list-settings__item-color",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(settings)[_unref(settingsIndex)][_unref(settingsItemIndex)].color) = $event))
      }, null, 512), [
        [_vModelText, _unref(settings)[_unref(settingsIndex)][_unref(settingsItemIndex)].color]
      ])
    ])
  ]))
}
}

})